import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const KEY = "qfp_offer_deadline";
const DURATION_MS = 15 * 60 * 1000;

function getDeadline() {
  const saved = Number(localStorage.getItem(KEY));
  if (saved) return saved;
  const d = Date.now() + DURATION_MS;
  localStorage.setItem(KEY, String(d));
  return d;
}

const pad = (n) => String(n).padStart(2, "0");

export const OfferCountdown = () => {
  const [deadline] = useState(getDeadline);
  const [left, setLeft] = useState(Math.max(0, deadline - Date.now()));

  useEffect(() => {
    if (left <= 0) return;
    const t = setInterval(() => setLeft(Math.max(0, deadline - Date.now())), 1000);
    return () => clearInterval(t);
  }, [deadline, left <= 0]); // eslint-disable-line react-hooks/exhaustive-deps

  if (left <= 0) {
    return (
      <p data-testid="offer-countdown-expired" className="text-xs font-semibold text-[#8a6d2f] uppercase tracking-widest">
        Aproveite enquanto este preço está disponível
      </p>
    );
  }

  const m = Math.floor(left / 60000);
  const s = Math.floor((left % 60000) / 1000);
  return (
    <div data-testid="offer-countdown" className="inline-flex items-center gap-3 rounded-2xl border border-[#E1CE9F] bg-[#FBF5E8] px-4 py-2 shadow-sm">
      <Clock className="w-4 h-4 text-[#B08B44] shrink-0" strokeWidth={2} />
      <span className="text-[11px] leading-tight text-[#6E5A4F] uppercase tracking-wider text-left">Oferta especial<br />termina em</span>
      <span className="flex items-center gap-1 font-sans-body font-bold text-[#3A2921] tabular-nums">
        <span data-testid="offer-countdown-minutes" className="rounded-lg bg-[#3A2921] text-[#F1D58F] text-xl px-2 py-0.5 min-w-[2.4rem] text-center">{pad(m)}</span>
        <span className="text-[#B08B44] text-xl animate-pulse">:</span>
        <span data-testid="offer-countdown-seconds" className="rounded-lg bg-[#3A2921] text-[#F1D58F] text-xl px-2 py-0.5 min-w-[2.4rem] text-center">{pad(s)}</span>
      </span>
    </div>
  );
};
